/**
 *   Generated file. Do not edit
 */

export const ResourceMetaData = {
  '/ethernet/ip': {
    put: {
      minApiVersion: 2.7,
      configModeRequired: false,
      schema: {
        type: 'string',
        format: 'ipv4',
        examples: ['0.0.0.0', '192.168.1.134'],
      },
    },
  },

  '/ethernet/gateway-ip': {
    put: {
      minApiVersion: 2.7,
      configModeRequired: false,
      schema: {
        type: 'string',
        format: 'ipv4',
      },
    },
  },

  '/ethernet/ip-mask': {
    put: {
      minApiVersion: 2.7,
      configModeRequired: false,
      schema: {
        type: 'string',
        format: 'ipv4mask',
      },
    },
  },

  '/ethernet/dns-ip': {
    put: {
      minApiVersion: 2.7,
      configModeRequired: false,
      schema: {
        type: 'string',
        format: 'ipv4',
      },
    },
  },

  '/ethernet/enabled': {
    put: {
      minApiVersion: 2.7,
      configModeRequired: false,
      schema: {
        type: 'boolean',
      },
    },
  },
};
